<template>
  <main class="container-fluid flex-grow-1 d-flex bg-lighter">
    <div class="row flex-grow-1 mt-5">
      <div class="col px-4">
        <section class="bg-white rounded mb-4 p-3 p-sm-4">
          <slot name="heading"></slot>
          <slot name="content"></slot>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Public-Layout"
}
</script>



// WEBPACK FOOTER //
// src/components/PublicLayout.vue